import React, { useEffect, useMemo } from 'react'
import DatePicker from 'react-datepicker'
import { useSearchParams } from 'react-router-dom'

import ArrowNext from '../assets/img/arrow-next.svg?react'
import ArrowPrev from '../assets/img/arrow-prev.svg?react'
import Calendar2Icon from '../assets/img/ico-calendar-2.svg?react'
import { getStartAndEndOfDay, getStartAndEndOfWeek } from '../utils/helpers'
import { formatISO } from 'date-fns'

const HeaderDataViewFilter = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const params = useMemo(
        () => ({
            view: searchParams.get('view') || 'resourceTimelineDay',
            startDate: searchParams.get('startDate'),
            endDate: searchParams.get('endDate'),
        }),
        [searchParams],
    )

    useEffect(() => {
        if (!params.startDate || !params.endDate) {
            const now = new Date()
            const { startDate, endDate } = getStartAndEndOfDay(now)
            setSearchParams({
                startDate: startDate,
                endDate: endDate,
            })
        }
    }, [])

    const handleDateChange = (date: Date | null) => {
        if (date) {
            setParams(date)
        }
    }

    const setParams = (date: Date) => {
        const { startDate, endDate } = getStartAndEndOfDay(date)
        const { startDate: startDateWeek, endDate: endDateWeek } =
            getStartAndEndOfWeek(date)
        setSearchParams((prev) => {
            const view = prev.get('view')
            prev.set(
                'startDate',
                view === 'resourceTimelineWeek' ? startDateWeek : startDate,
            )
            prev.set(
                'endDate',
                view === 'resourceTimelineWeek' ? endDateWeek : endDate,
            )
            return prev
        })
    }

    const handleIncrementDate = () => {
        const date = new Date(params.startDate || new Date())
        const view = params.view
        date.setDate(date.getDate() + (view === 'resourceTimelineDay' ? 1 : 7))
        setParams(date)
    }

    const handleDecrementDate = () => {
        const date = new Date(params.startDate || new Date())
        const view = params.view
        date.setDate(date.getDate() - (view === 'resourceTimelineDay' ? 1 : 7))
        setParams(date)
    }

    return (
        <div className="calendar-header">
            <div className="flex items-center gap-20">
                <div className="flex items-center w-250">
                    {params.view === 'resourceTimelineDay' ? (
                        <DatePicker
                            selected={
                                params.startDate
                                    ? new Date(params.startDate)
                                    : null
                            }
                            className="calendar-title"
                            placeholderText="Select date"
                            onChange={(date: Date | null) =>
                                handleDateChange(date)
                            }
                            dateFormat={'MMM d, yyyy'}
                        />
                    ) : (
                        <DatePicker
                            wrapperClassName="w-full"
                            selectsRange={true}
                            startDate={
                                params.startDate === 'null' || !params.startDate
                                    ? undefined
                                    : new Date(params.startDate)
                            }
                            endDate={
                                params.endDate === 'null' || !params.endDate
                                    ? undefined
                                    : new Date(params.endDate)
                            }
                            className="calendar-title"
                            onChange={(date) => {
                                if (!date) return
                                setSearchParams((prev) => {
                                    prev.set(
                                        'startDate',
                                        date[0]
                                            ? formatISO(date[0])
                                            : String(date[0]),
                                    )
                                    prev.set(
                                        'endDate',
                                        date[1]
                                            ? formatISO(date[1])
                                            : String(date[1]),
                                    )
                                    return prev
                                })
                            }}
                            dateFormat={'MMM d, yyyy'}
                        />
                    )}
                    <span className="ico absolute right-4">
                        <Calendar2Icon />
                    </span>
                </div>
                <div className="flex items-center gap-8">
                    <button
                        className="btn btn--navigation btn--square btn--xs rounded-full"
                        onClick={handleDecrementDate}
                    >
                        <ArrowPrev />
                    </button>
                    <button
                        className="btn btn--navigation btn--square btn--xs rounded-full"
                        onClick={handleIncrementDate}
                    >
                        <ArrowNext />
                    </button>
                </div>
            </div>
            <div className="c-h-item">
                <label className="calendar-mode" id="mode-days">
                    {['resourceTimelineDay', 'resourceTimelineWeek'].map(
                        (item, index) => (
                            <label key={index} className="calendar-mode-item">
                                <input
                                    type="radio"
                                    checked={params.view === item}
                                    hidden
                                    onChange={() => {
                                        setSearchParams((prev) => {
                                            prev.set('view', item)
                                            return prev
                                        })
                                    }}
                                />
                                <div className="calendar-mode-btn btn">
                                    {item.replace('resourceTimeline', '')}
                                </div>
                            </label>
                        ),
                    )}
                </label>
            </div>
        </div>
    )
}

export default HeaderDataViewFilter
